import Adventure from './Adventure.parm';
export default Adventure;